{
  "overview": {
    "title": "Overview",
    "kpi": {
      "total": "Total Orders",
      "notPlaced": "Not Placed Orders",
      "activeWorkflows": "Orders with active workflows"
    }
  },
  "orders": {
    "title": " Orders",
    "filters": {
      "search": "Search",
      "filter": "Filter",
      "sort": "Sort",
      "milestone": "Milestone",
      "eventStatus": "Event Status",
      "clearAll": "Clear all"
    },
    "table": {
      "headers": {
        "orderId": "Order ID",
        "servicerLoanNumber": "Servicer Loan Number",
        "client": "Client",
        "vendor": "Vendor",
        "orderStatus": "Order Status",
        "orderType": "Order Type",
        "createDate": "Create Date",
        "dueDate": "Client Due Date",
        "slaStatus": "Client SLA Status"
      },
      "empty": "No results match the current filters."
    }
  },
  "documents": {
    "filters": {
      "documentType": "Document Type",
      "source": "Source",
      "uploadedBy": "Uploaded By",
      "uploadDate": "Upload Date",
      "lastUpdate": "Last Update",
      "uploadDocument": "Upload Document"
    }
  }
}
